export default "__VITE_ASSET__3f403298__"